import { Box, Typography } from '@mui/material';
import { DuplicatesTab } from '../admin/DuplicatesTab';

export function DuplicatesPage() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" mb={2}>
        Possible duplicates
      </Typography>
      <DuplicatesTab />
    </Box>
  );
}
